// import React, { useState, useRef } from 'react'
// import Input from '../../../Login/Input'
// import Button from '../../../../UI/Button'
// import { useNavigate } from 'react-router-dom';
// import ModalWrapper from '../../../../UI/ModalWrapper'
// import { useReportClientMutation } from '../../../../services/coachScreenApi';
// import { ToastContainer, toast } from 'react-toastify'
// import api from '../../../../services/api';
// import { useEffect } from 'react';


// function VideoJoinModal({ onCloseModal, videoLink, currentChatUser, feedbackModal }) {

//     const form = useRef(null)
//     const navigate = useNavigate();
//     const [vLink, setvLink] = useState(null)
//     const [loading, setloading] = useState(false)

//     const handleReportUser = async (e) => {
//         e.preventDefault();

//     }

//     useEffect(() => {
//         setvLink(videoLink)
//     }, [videoLink])

//     const createNewVideo = () => {
//         setloading(true)
//         const formData = new FormData();
//         formData.append("booking_id", currentChatUser?.last_message.booking_id)
//         formData.append("client_id", currentChatUser?.user_id)

//         api.post(`employee/generate-meeting-link`, formData, {
//             headers: {
//                 authorization: `Bearer ${localStorage.getItem("livtoken")}`,
//             }
//         }).then((res) => {
//             console.log(res.data.data, "RES*** in meeting again")
//             setvLink(res.data.data)
//             setloading(false)

//         }).catch((err) => {
//             toast.warn(`${err}`, {
//                 position: "top-center",
//                 autoClose: 5000,
//                 hideProgressBar: false,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 progress: undefined,
//                 theme: "light",
//             });
//         })
//     }

//     const joinButton = () => {
//         window.open(vLink)
//         onCloseModal()
//         feedbackModal()
//     }

//     return (
//         <ModalWrapper>
//             <ToastContainer />
//             {
//                 vLink ? <div className="bg-white rounded-3xl text-xl text-center font-ubuntu px-12 py-12 w-6/12">
//                     <span className="font-semibold">
//                         Start the session?
//                     </span>
//                     <form ref={form} onSubmit={handleReportUser} >
//                         <div className="flex gap-12 w-full mt-8 justify-center">
//                             <a onClick={joinButton} className="bg-lighterOrange w-40 h-8 text-[17px] text-lightOrange font-medium cursor-pointer rounded-3xl">Join</a>
//                             {/* <Button onClick={() => {
//                                 navigator.clipboard.writeText(vLink ? vLink : "");
//                                 toast.warn(`Link copied to clipboard`, {
//                                     position: "top-center",
//                                     autoClose: 5000,
//                                     hideProgressBar: false,
//                                     closeOnClick: true,
//                                     pauseOnHover: true,
//                                     draggable: true,
//                                     progress: undefined,
//                                     theme: "light",
//                                 });
//                             }} className="bg-lighterOrange w-40 h-8 text-[17px] text-lightOrange font-medium">Copy Link</Button> */}
//                             <Button onClick={onCloseModal} className="bg-lighterOrange w-40 h-8 text-[17px] text-lightOrange font-medium">Close</Button>
//                         </div>
//                     </form>
//                 </div> :
//                     <div className="bg-white rounded-3xl text-xl text-center font-ubuntu px-12 py-12 w-3/12">
//                         <span className="font-semibold">
//                             create a new link?
//                         </span>
//                         <form ref={form} onSubmit={handleReportUser} >
//                             {
//                                 loading ? <div className="flex flex-row justify-center">
//                                     <p className="text-sm">Loading...</p>
//                                 </div> : <p onClick={() => {
//                                     navigator.clipboard.writeText(vLink ? vLink : "");
//                                     toast.warn(`Link copied to clipboard`, {
//                                         position: "top-center",
//                                         autoClose: 5000,
//                                         hideProgressBar: false,
//                                         closeOnClick: true,
//                                         pauseOnHover: true,
//                                         draggable: true,
//                                         progress: undefined,
//                                         theme: "light",
//                                     });
//                                 }} className="text-sm cursor-pointer">{vLink ? vLink : null}</p>
//                             }
//                             <div className="flex gap-12 w-full mt-8  justify-center">
//                                 <Button onClick={createNewVideo} className="bg-lighterOrange w-40 h-8 text-[17px] text-lightOrange font-medium">Create</Button>
//                                 <Button onClick={onCloseModal} className="bg-lighterOrange w-40 h-8 text-[17px] text-lightOrange font-medium">Close</Button>
//                             </div>
//                         </form>
//                     </div>
//             }
//         </ModalWrapper>
//     )
// }

// export default VideoJoinModal

// import React, { useEffect, useRef, useState } from 'react';
// import ModalWrapper from '../../../../UI/ModalWrapper';
// import DailyIframe from '@daily-co/daily-js';
// import { ToastContainer, toast } from 'react-toastify';
// import Button from '../../../../UI/Button';
// import api from '../../../../services/api';
// import Draggable from 'react-draggable';
// function VideoJoinModal({ onCloseModal, videoLink, currentChatUser, feedbackModal }) {
//   const callFrameRef = useRef(null);
//   const callFrameInstance = useRef(null);
// console.log(videoLink);
//   const [loading, setLoading] = useState(false);
//   const [meetingURL, setMeetingURL] = useState('');
//   const [isMinimized,setIsMinimized]=useState(false)
//   const [draggablePosition, setDraggablePosition] = useState({ x: 0, y: 0 });
//   useEffect(() => {
//     if (videoLink) {
//       try {
//         // Parse JSON string to object and get the 'url'
//         const obj = typeof videoLink === 'string' ? JSON.parse(videoLink) : videoLink;
//         setMeetingURL(obj.url);
//       } catch (e) {
//         setMeetingURL('');
//       }
//     }
//   }, [videoLink]);
//   const createNewVideo = () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("booking_id", currentChatUser?.last_message.booking_id);
//     formData.append("client_id", currentChatUser?.user_id);

//     api.post(`employee/generate-meeting-link`, formData, {
//       headers: {
//         authorization: `Bearer ${localStorage.getItem("livtoken")}`,
//       }
//     }).then(res => {
//       console.log(res);
//      const meetingInfo = JSON.parse(res.data.data);
//  setMeetingURL(meetingInfo.url)
//       // setMeetingURL(res.data.data);
//       setLoading(false);
//     }).catch(err => {
//       setLoading(false);
//       toast.warn(`Error generating meeting link: ${err.message || err}`, {
//         position: "top-center",
//         autoClose: 5000,
//         theme: "light"
//       });
//     });
//   };

//   // Setup Daily.co call frame when meetingURL is ready
//   useEffect(() => {
//     if (!meetingURL || !callFrameRef.current) return;

//     // Clean up old frame if any
//     if (callFrameInstance.current) {
//       callFrameInstance.current.leave();
//       callFrameInstance.current.destroy();
//       callFrameInstance.current = null;
//       callFrameRef.current.innerHTML = '';
//     }

//     // Create new Daily iframe call frame
//     const callFrame = DailyIframe.createFrame({
//       iframeStyle: {
//         width: '100%',
//         height:'90vh',
//         border: '0',
//         borderRadius: '12px'
//       },
//       showLeaveButton: true,
//       // optional: you can customize buttons, themes, etc.
//       // You may want to disable allowMultipleCallInstances here if only one allowed
//       allowMultipleCallInstances: true
//     });

//     callFrame.on('left-meeting', () => {
//       onCloseModal();
//       // if (feedbackModal) feedbackModal();
//     });
 

//     callFrameRef.current.appendChild(callFrame.iframe());
//     callFrame.join({ url: meetingURL });
//     callFrameInstance.current = callFrame;

//      // Defer join to next tick to allow iframe setup complete
//   setTimeout(() => {
//     callFrame.join({ url: meetingURL }).catch(console.error);
//     callFrameInstance.current = callFrame;
//   }, 0);
//     // Cleanup on unmount
//     return () => {
//       if (callFrameInstance.current) {
//         callFrameInstance.current.leave();
//         callFrameInstance.current.destroy();
//         callFrameInstance.current = null;
//       }
//       if (callFrameRef.current) callFrameRef.current.innerHTML = '';
//     };
//   }, [meetingURL, onCloseModal, feedbackModal]);

//   // If you want to close modal manually any time
//   const handleClose = () => {
//     if (callFrameInstance.current) {
//       callFrameInstance.current.leave();
//       callFrameInstance.current.destroy();
//     }
//     onCloseModal();
//   };
//  const onDragStop = (e, data) => {
//     setDraggablePosition({ x: data.x, y: data.y });
//   };
//   return (
//     <>
//      <ModalWrapper>
//       <ToastContainer />
//      {/* {!isMinimized ?  */}
     
//      <div 
      
//        className={`rounded-3xl font-ubuntu p-6 mx-auto bg-white w-[98%] min-h-[90vh]`}
//   style={{ transition: 'all 0.3s ease' }}
//       >

//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-xl font-semibold">Coach Video Call</h2>
       
     
   
//           <button onClick={handleClose} className="text-red-600 font-semibold">Close</button>
//         </div>

//         {/* If no meeting link yet, show create button */}
//         {!meetingURL ? (
//           <div className="text-center">
//             <p className="mb-4">Create a new meeting link to start the session.</p>
//             <Button onClick={createNewVideo} disabled={loading}>
//               {loading ? 'Creating...' : 'Create Meeting Link'}
//             </Button>
//           </div>
//         ) : (
//           <>
//             {/* The Daily.co Call Frame */}
//             <div ref={callFrameRef} className="mb-4" style={{
//       width:'100%',
//       height: '100%',
//       borderRadius: '12px',
//       overflow: 'hidden',
      
//     }}/>

            
//             <p className="text-xs text-gray-500 break-all mt-2">Meeting URL: {meetingURL}</p>
//           </>
//         )}
//       </div>

    
//     </ModalWrapper>
//     </>
//   );
// }

// export default VideoJoinModal;

import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Button from '../../../../UI/Button';
import api from '../../../../services/api';

function VideoJoinModal({ onCloseModal, videoLink, currentChatUser }) {
  const [loading, setLoading] = useState(false);
  const [meetingURL, setMeetingURL] = useState('');

  // Parse and set meeting URL if already passed
  useEffect(() => {
    if (videoLink) {
      try {
        const obj = typeof videoLink === 'string' ? JSON.parse(videoLink) : videoLink;
        if (obj.url) {
          setMeetingURL(obj.url);
          window.open(obj.url, '_blank', 'noopener,noreferrer'); // open in new tab
          onCloseModal(); // close modal (or remove this line if you're not showing a modal anymore)
        }
      } catch (e) {
        setMeetingURL('');
      }
    }
  }, [videoLink, onCloseModal]);

  // Create new meeting if not already passed
  const createNewVideo = () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("booking_id", currentChatUser?.last_message.booking_id);
    formData.append("client_id", currentChatUser?.user_id);

    api.post(`employee/generate-meeting-link`, formData, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("livtoken")}`,
      }
    }).then(res => {
      const meetingInfo = JSON.parse(res.data.data);
      setMeetingURL(meetingInfo.url);
      window.open(meetingInfo.url, '_blank', 'noopener,noreferrer'); // open in new tab
      setLoading(false);
      onCloseModal(); // close modal after opening
    }).catch(err => {
      setLoading(false);
      toast.warn(`Error generating meeting link: ${err.message || err}`, {
        position: "top-center",
        autoClose: 5000,
        theme: "light"
      });
    });
  };

  return (
    <>
      <ToastContainer />
      {!meetingURL && (
        <div className="text-center p-4 bg-white rounded shadow">
          <h2 className="text-xl font-semibold mb-4">Coach Video Call</h2>
          <p className="mb-4">Create a new meeting link to start the session.</p>
          <Button onClick={createNewVideo} disabled={loading}>
            {loading ? 'Creating...' : 'Create Meeting Link'}
          </Button>
          <div className="mt-4">
            <button onClick={onCloseModal} className="text-red-600 font-semibold">Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}

export default VideoJoinModal;


